export const translations = {
  en: {
    // navbar
    home: "Home",
    browse: "Browse",
    myUploads: "My Uploads",
    upload: "Upload",
    signIn: "Sign In",
    signOut: "Sign Out",
    createAccount: "Create Account",
    // hero
    everythingFree: "Everything is FREE",
    heroTitle: "Free media assets for",
    heroAccent: "every creator",
    heroSubtitle:
      "Access thousands of professional templates, documents, images, icons, 3D graphics, and videos uploaded by our community — all completely free.",
    browseAssets: "Browse Free Assets",
    noPayment: "No Payment Required",
    unlimited: "Unlimited Downloads",
    commercial: "Commercial Use",
    // categories
    twelveTypes: "12 media types, all completely free",
    typesDesc:
      "Access our complete collection of professional assets across all major media formats. No subscriptions, no hidden costs — everything is free forever.",
    allCategoriesFree: "All Categories Free",
    // sections
    mostDownloaded: "Most Downloaded Assets",
    mostDownloadedDesc: "Discover what creative professionals are using to elevate their projects this week",
    qualityAssets: "Quality media assets, completely free",
    qualityDesc:
      "MediaVault provides high-quality multimedia resources at absolutely no cost. No subscriptions, no trials, no hidden fees — just free access to professional assets forever.",
    completelyFree: "Completely Free",
    completelyFreeDesc: "No subscriptions, no hidden fees, no trials — everything is free forever",
    instantAccess: "Instant Access",
    instantAccessDesc: "Download any asset immediately after joining — no payment required",
    everythingHundred: "Everything is 100% Free",
    everythingHundredDesc:
      "We believe great design shouldn't cost a fortune. That's why every single asset in our library is completely free.",
    readyToDownload: "Ready to download free assets?",
    readyToDownloadDesc: "Browse our complete library. Simply create an account to upload — no payment information required.",
    startDownloading: "Start Downloading Free",
    browseCollections: "Browse Free Collections",
    noCard: "No Credit Card",
    noSubs: "No Subscriptions",
    noFees: "No Hidden Fees",
    // categories grid
    powerpoint: "PowerPoint Files",
    powerpointDesc: "Professional presentation templates and slide designs",
    word: "Word Files",
    wordDesc: "Document templates, reports, and professional layouts",
    excel: "Excel Files",
    excelDesc: "Spreadsheet templates, calculators, and data tools",
    images: "Images",
    imagesDesc: "High-quality photos, illustrations, and graphics",
    threeDIcons: "3D Icons",
    threeDIconsDesc: "Modern dimensional icons and 3D graphic elements",
    icons: "Icons",
    iconsDesc: "Vector icons, symbol libraries, and interface elements",
    animation: "Animation",
    animationDesc: "Motion graphics and animated elements",
    stickers: "Stickers",
    stickersDesc: "Fun decorative stickers and emojis",
    cv: "CV Templates",
    cvDesc: "Professional resume and CV templates",
    school: "School Work",
    schoolDesc: "Educational worksheets and resources",
    video: "Video",
    videoDesc: "Motion graphics and video clips",
    other: "Other",
    otherDesc: "Documents, archives and miscellaneous files",
    // search/browse
    searchPlaceholder: "Search templates, icons, photos…",
    search: "Search",
    allAssets: "All Assets",
    recent: "Recent",
    popular: "Most Downloaded",
    download: "Download",
    downloads: "downloads",
    by: "by",
    noResults: "No assets found. Be the first to upload!",
    // auth
    email: "Email",
    password: "Password",
    name: "Full Name",
    loginTitle: "Welcome back",
    loginSub: "Sign in to upload and manage your assets",
    registerTitle: "Create your account",
    registerSub: "Join the community and start sharing free assets",
    haveAccount: "Already have an account?",
    needAccount: "Don't have an account?",
    forgotPassword: "Forgot password?",
    forgotTitle: "Reset your password",
    forgotSub: "Enter the email associated with your account and we'll send a reset link.",
    forgotSend: "Send reset link",
    forgotSent: "Reset link sent",
    forgotCheckEmail: "Check your inbox. The link expires in one hour.",
    resetTitle: "Choose a new password",
    resetSub: "Pick something memorable but strong (at least 6 characters).",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    resetSubmit: "Update password",
    resetSuccess: "Password updated. Please sign in.",
    passwordMismatch: "Passwords don't match",
    light: "Light",
    dark: "Dark",
    // upload
    uploadTitle: "Upload an asset",
    uploadSub: "Share your work with creators around the world",
    title: "Title",
    description: "Description",
    category: "Category",
    selectFile: "Select file or drop here",
    uploadBtn: "Upload Now",
    uploading: "Uploading…",
    uploadSuccess: "Upload successful!",
    // my uploads
    myUploadsTitle: "My Uploads",
    myUploadsSub: "Manage assets you have shared",
    noUploads: "You haven't uploaded anything yet.",
    delete: "Delete",
    confirmDelete: "Delete this file?",
    // stats
    freeAssets: "Free Assets",
    happyCreators: "Happy Creators",
    freeForever: "Free Forever",
    freeAccess: "Free Access",
    // footer
    tagline: "A community-powered media library — built for creators, free forever.",
    rights: "All rights reserved.",
    // misc
    cost: "Cost",
    forever: "$0 Forever",
    free100: "100% FREE",
    everythingFreeBadge: "Everything is FREE",
    curated: "Community Driven",
  },
  ar: {
    home: "الرئيسية",
    browse: "تصفح",
    myUploads: "ملفاتي",
    upload: "رفع",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    createAccount: "إنشاء حساب",
    everythingFree: "كل شيء مجاني",
    heroTitle: "وسائط مجانية لكل",
    heroAccent: "صانع محتوى",
    heroSubtitle:
      "الوصول إلى آلاف القوالب الاحترافية والمستندات والصور والأيقونات والرسومات ثلاثية الأبعاد والفيديوهات التي رفعها المجتمع — كل ذلك مجاناً تماماً.",
    browseAssets: "تصفح الوسائط المجانية",
    noPayment: "بدون دفع",
    unlimited: "تنزيلات غير محدودة",
    commercial: "استخدام تجاري",
    twelveTypes: "12 نوع وسائط، كلها مجانية",
    typesDesc:
      "الوصول إلى مجموعتنا الكاملة من الأصول الاحترافية بجميع تنسيقات الوسائط الرئيسية. بدون اشتراكات أو رسوم خفية — كل شيء مجاني للأبد.",
    allCategoriesFree: "كل الفئات مجانية",
    mostDownloaded: "الأكثر تحميلاً",
    mostDownloadedDesc: "اكتشف ما يستخدمه المبدعون لترقية مشاريعهم هذا الأسبوع",
    qualityAssets: "وسائط عالية الجودة، مجانية بالكامل",
    qualityDesc:
      "يوفر MediaVault موارد وسائط متعددة عالية الجودة دون أي تكلفة. لا اشتراكات، لا تجارب، لا رسوم خفية — فقط وصول مجاني للأصول الاحترافية إلى الأبد.",
    completelyFree: "مجاني تماماً",
    completelyFreeDesc: "لا اشتراكات ولا رسوم خفية ولا تجارب — كل شيء مجاني للأبد",
    instantAccess: "وصول فوري",
    instantAccessDesc: "حمّل أي ملف فوراً بعد التسجيل — لا حاجة لأي دفع",
    everythingHundred: "كل شيء مجاني 100%",
    everythingHundredDesc: "نحن نؤمن أن التصميم العظيم لا يجب أن يكون باهظ الثمن. لذلك كل أصل في مكتبتنا مجاني تماماً.",
    readyToDownload: "جاهز لتحميل الأصول المجانية؟",
    readyToDownloadDesc: "تصفح مكتبتنا الكاملة. أنشئ حساباً لرفع ملفاتك — لا حاجة لمعلومات الدفع.",
    startDownloading: "ابدأ التحميل مجاناً",
    browseCollections: "تصفح المجموعات المجانية",
    noCard: "بدون بطاقة ائتمان",
    noSubs: "بدون اشتراكات",
    noFees: "بدون رسوم خفية",
    powerpoint: "ملفات PowerPoint",
    powerpointDesc: "قوالب عروض تقديمية احترافية",
    word: "ملفات Word",
    wordDesc: "قوالب مستندات وتقارير احترافية",
    excel: "ملفات Excel",
    excelDesc: "قوالب جداول بيانات وحاسبات وأدوات",
    images: "صور",
    imagesDesc: "صور عالية الجودة ورسومات",
    threeDIcons: "أيقونات ثلاثية الأبعاد",
    threeDIconsDesc: "أيقونات حديثة بأبعاد ثلاثية وعناصر رسومية",
    icons: "أيقونات",
    iconsDesc: "أيقونات متجهة ومكتبات رموز وعناصر واجهة",
    animation: "رسوم متحركة",
    animationDesc: "رسومات حركة وعناصر متحركة",
    stickers: "ملصقات",
    stickersDesc: "ملصقات وإيموجي للزينة",
    cv: "قوالب السيرة الذاتية",
    cvDesc: "قوالب سيرة ذاتية احترافية",
    school: "أعمال مدرسية",
    schoolDesc: "أوراق عمل تعليمية وموارد",
    video: "فيديو",
    videoDesc: "رسومات حركة ومقاطع فيديو",
    other: "أخرى",
    otherDesc: "مستندات وأرشيفات وملفات متنوعة",
    searchPlaceholder: "ابحث عن قوالب، أيقونات، صور…",
    search: "بحث",
    allAssets: "كل الأصول",
    recent: "الأحدث",
    popular: "الأكثر تحميلاً",
    download: "تحميل",
    downloads: "تحميل",
    by: "بواسطة",
    noResults: "لا توجد أصول. كن أول من يرفع ملفاً!",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    loginTitle: "مرحباً بعودتك",
    loginSub: "سجل الدخول لرفع وإدارة أصولك",
    registerTitle: "أنشئ حسابك",
    registerSub: "انضم إلى المجتمع وابدأ بمشاركة الأصول المجانية",
    haveAccount: "لديك حساب بالفعل؟",
    needAccount: "ليس لديك حساب؟",
    forgotPassword: "نسيت كلمة المرور؟",
    forgotTitle: "استعادة كلمة المرور",
    forgotSub: "أدخل البريد الإلكتروني المرتبط بحسابك وسنرسل لك رابط الاستعادة.",
    forgotSend: "إرسال رابط الاستعادة",
    forgotSent: "تم إرسال الرابط",
    forgotCheckEmail: "تحقق من بريدك. الرابط صالح لساعة واحدة.",
    resetTitle: "اختر كلمة مرور جديدة",
    resetSub: "اختر شيئاً قوياً يسهل تذكره (6 أحرف على الأقل).",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    resetSubmit: "تحديث كلمة المرور",
    resetSuccess: "تم تحديث كلمة المرور. سجل الدخول الآن.",
    passwordMismatch: "كلمات المرور غير متطابقة",
    light: "نهاري",
    dark: "ليلي",
    uploadTitle: "رفع ملف",
    uploadSub: "شارك أعمالك مع المبدعين حول العالم",
    title: "العنوان",
    description: "الوصف",
    category: "الفئة",
    selectFile: "اختر ملفاً أو أفلته هنا",
    uploadBtn: "ارفع الآن",
    uploading: "جاري الرفع…",
    uploadSuccess: "تم الرفع بنجاح!",
    myUploadsTitle: "ملفاتي",
    myUploadsSub: "إدارة الأصول التي شاركتها",
    noUploads: "لم ترفع أي ملف بعد.",
    delete: "حذف",
    confirmDelete: "حذف هذا الملف؟",
    freeAssets: "أصل مجاني",
    happyCreators: "مبدع سعيد",
    freeForever: "مجاني للأبد",
    freeAccess: "وصول مجاني",
    tagline: "مكتبة وسائط مدعومة من المجتمع — مبنية للمبدعين، مجانية للأبد.",
    rights: "جميع الحقوق محفوظة.",
    cost: "التكلفة",
    forever: "0$ للأبد",
    free100: "مجاني 100%",
    everythingFreeBadge: "كل شيء مجاني",
    curated: "مدفوع بالمجتمع",
  },
};

export const CATEGORY_LIST = [
  { id: "powerpoint", color: "#F97316", icon: "FileText" },
  { id: "word", color: "#3B82F6", icon: "FileText" },
  { id: "excel", color: "#22C55E", icon: "FileSpreadsheet" },
  { id: "images", color: "#A855F7", icon: "Image" },
  { id: "3d-icons", color: "#06B6D4", icon: "Box" },
  { id: "icons", color: "#EAB308", icon: "Zap" },
  { id: "animation", color: "#EF4444", icon: "Video" },
  { id: "stickers", color: "#EC4899", icon: "Sticker" },
  { id: "cv", color: "#14B8A6", icon: "FileBadge" },
  { id: "school", color: "#10B981", icon: "GraduationCap" },
  { id: "video", color: "#F59E0B", icon: "Film" },
  { id: "other", color: "#64748B", icon: "Folder" },
];
